import { render, staticRenderFns } from "./mallCoopManage.vue?vue&type=template&id=6bf18b4c&scoped=true&"
import script from "./mallCoopManage.vue?vue&type=script&lang=js&"
export * from "./mallCoopManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf18b4c",
  null
  
)

export default component.exports